module.exports = __webpack_public_path__ + "img/l4.dfb42626.png";